import {$dom} from '../../helpers/dom';
import { Datepicker } from '../../plugins/datepicker/main';
import ru from '../../plugins/datepicker/i18n/locales/ru.js';
import variables from '../../variables';
import {isElement} from '../../helpers/_utilities';
import {$events} from '../../helpers/events';

Object.assign(Datepicker.locales, ru);

const {
	exist,
	callAll,
	hasClass,
	get
} = $dom;

export default function datepicker(
	targetsSelector = '.js-calendar',
	rangeSelector = '.js-calendar-range',
	rangeFromFieldClassName = 'js-calendar-from',
	rangeToFieldClassName = 'js-calendar-to'
) {

	if (exist(targetsSelector)) {

		function handleChangeDate(event) {
			const {detail: data, target} = event;

			const rangeParent = target.closest(rangeSelector);

			if (isElement(rangeParent)) {

				if (hasClass(target, rangeFromFieldClassName)) {
					get('.'+rangeToFieldClassName, rangeParent).datepicker.setOptions({
						minDate: data.date
					})
				}

				if (hasClass(target, rangeToFieldClassName)) {

				}

			}
		}

		const
			init = () => {
				callAll(targetsSelector, input => {

					const
						{
							prevIconPath,
							nextIconPath
						} = input.dataset,
						iconClasses = 'svg-icon svg-icon--circle-arrow',
						prevArrow = `<svg class="${iconClasses}"><use xlink:href="${prevIconPath}"></use></svg>`,
						nextArrow = `<svg class="${iconClasses}"><use xlink:href="${nextIconPath}"></use></svg>`
					;

					input.datepicker = new Datepicker(input, {
						language: 'ru',
						autohide: true,
						orientation: 'bottom',
						container: variables.selectors.pageWrapper,
						format: 'dd.mm.yyyy',
						type: 'range',
						inputs: '',
						prevArrow,
						nextArrow,
					});
				});

				$events.delegate.on('changeDate', targetsSelector, handleChangeDate);
			},

			destroy = () => {
				callAll(targetsSelector, input => {

					let {datepicker} = input;

					if (datepicker instanceof Datepicker) {
						datepicker.destroy();
						datepicker = null
					}
				});
				$events.delegate.on('changeDate', targetsSelector, handleChangeDate);
			}
		;
		return {init, destroy}
	}

	return null;
}
